<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <form-wizard shape="circle"
                      color="#005B5B" title="" subtitle="">
            <tab-content :title="$t('social_service.personal_info')" icon="ri-home-4-line" :before-change="tabSubmitPersonal">
              <Personal :patient_form="patient_form" :search="search" ref="personal"/>
            </tab-content>
            <tab-content :title="$t('social_service.add_fam_info')" icon="ri-home-4-line" :before-change="tabSubmitAddress">
              <Address :address_family_info="address_family_info" ref="address"/>
            </tab-content>
            <tab-content :title="$t('social_service.admiss')" icon="ri-home-4-line" :before-change="tabSubmitAdmission">
              <Admission :admisson_other_info="admisson_other_info" :patient_form="patient_form" ref="admission"/>
            </tab-content>
            <tab-content :title="$t('social_service.social_eco')" icon="ri-home-4-line" :before-change="finalSubmit">
              <SocioEco :socio_ecio="socio_ecio" :med_assistance="med_assistance" :patient_form="patient_form" :admisson_other_info="admisson_other_info" :address_family_info="address_family_info" :info_id="info_id" ref="info"/>
            </tab-content>
            <button slot="finish" class="wizard-btn-custom" style="background-color: rgb(0, 91, 91); border-color: rgb(0, 91, 91); color: white;" @click="addForm">Submit</button>
          </form-wizard>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Personal from './SocialInfo.vue'
import Address from './Address.vue'
import Admission from './Admission.vue'
import SocioEco from './SocioEco.vue'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
// import toggleStatus from '@/Utils/toggle-status'
import { caseHistoryDetailsApi } from '../../../api/routes'

export default {
  components: {
    FormWizard,
    TabContent,
    Personal,
    Address,
    Admission,
    SocioEco
  },
  mounted () {
    core.index()
    this.setLang()
  },
  created () {
    if (this.$route.params.case_id) {
      this.info_id = this.$route.params.case_id
      const params = null
      RestApi.getData(hospitalServiceBaseUrl, `${caseHistoryDetailsApi}/${this.$route.params.case_id}`, params).then(response => {
          if (response.success) {
            this.search.office_id = response.data.hospital_id
            this.search.patient_type_id = response.data.patient_type
            this.search.form_no = response.data.form_no
            this.search.auto_id = response.data.auto_id
          }
      })
    }
  },
  data () {
    return {
      lang: 'en',
      userDetails: [],
      userName: '',
      userId: 0,
      search: {
        office_id: 0,
        patient_type_id: 0,
        form_no: '',
        auto_id: ''
      },
      patient_form: {
        case_history_main_id: 0,
        case_history_no: 0,
        regis_id: '',
        office_id: 0,
        patient_type_id: 0,
        form_no: '',
        patient_name: '',
        patient_name_bn: '',
        father_name: '',
        father_name_bn: '',
        mother_name: '',
        mother_name_bn: '',
        id_type: 0,
        id_no: '',
        guardian_name: '',
        guardian_name_bn: '',
        relation: '',
        relation_bn: '',
        gender: '',
        age: 0,
        weight: '',
        blood_group: '',
        blood_group_bn: '',
        gender_id: '0',
        occupation_id: 0,
        occupation: '',
        occupation_bn: '',
        monthly_income: 0,
        marital_status: 0,
        qualification: '',
        qualification_bn: '',
        religion: '',
        religion_bn: '',
        nationality: '',
        nationality_bn: '',
        father_education_status: '',
        mother_education_status: '',
        earning_member: '',
        monthly_family_income: '',
        income_source: '',
        family_category: '',
        no_of_family_member: '',
        present_address: '',
        mobile_no: '',
        area_type_id: 0,
        city_corporation_id: 0,
        ward_id: 0,
        pauroshoba_id: 0,
        division_id: 0,
        district_id: 0,
        upazila_id: 0,
        union_id: 0,
        village_en: '',
        village_bn: '',
        reg_date: this.currentDate(),
        phone_no: '',
        hos_reg_no: '',
        hos_reg_date: this.currentDate(),
        admission_type: '0',
        department_id: '-1',
        hos_ward_id: '0',
        hos_bed_id: '0',
        department: '',
        department_bn: '',
        ward: '',
        bed_no: '',
        guardian_mobile_no: '',
        address: '',
        address_bn: '',
        doctor_name: '',
        doctor_name_bn: '',
        patient_situation: '',
        patient_situation_bn: '',
        so_officer_comment: '',
        so_officer_comment_bn: '',
        related_document: '',
        related_document_bn: '',
        attachment: ''
      },
      address_family_info: {
        case_history_main_id: 0,
        case_history_no: '',
        socio_economic_info_id: '',
        area_type_id: 0,
        city_corporation_id: 0,
        pauroshoba_id: 0,
        ward_id: 0,
        country_id: 0,
        division_id: 0,
        union_id: 0,
        district_id: 0,
        thana_id: 0,
        upazilla_id: 0,
        permanent_address: '',
        permanent_address_bn: '',
        pre_area_type_id: 0,
        pre_city_corporation_id: 0,
        pre_pauroshoba_id: 0,
        pre_ward_id: 0,
        pre_country_id: 0,
        pre_division_id: 0,
        pre_union_id: 0,
        pre_district_id: 0,
        pre_upazilla_id: 0,
        present_address: '',
        present_address_bn: '',
        familyInfo: []
      },
      admisson_other_info: {
        related_documents: [],
        case_history_no: '',
        socio_economic_info_id: '',
        case_history_main_id: 0,
        regular: 0,
        regular_comment: '',
        regular_comment_bn: '',
        vaccination: 0,
        vaccination_comment: '',
        vaccination_comment_bn: '',
        food: 0,
        food_comment: '',
        food_comment_bn: '',
        smoking: 0,
        smoking_comment: '',
        smoking_comment_bn: '',
        physical: 0,
        physical_comment: '',
        physical_comment_bn: '',
        medicine: 0,
        medicine_comment: '',
        medicine_comment_bn: '',
        other_disease: 0,
        other_disease_comment: '',
        other_disease_comment_bn: '',
        family_history: 0,
        family_history_comment: '',
        family_history_comment_bn: ''
      },
      socio_ecio: {
        case_history_main_id: 0,
        personal: 0,
        personal_comment: '',
        personal_comment_bn: '',
        affected: 0,
        affected_comment: '',
        affected_comment_bn: '',
        jakat: 0,
        jakat_comment: '',
        jakat_comment_bn: '',
        village_centric: 0,
        village_centric_comment: '',
        village_centric_comment_bn: '',
        city_centric: 0,
        city_centric_comment: '',
        city_centric_comment_bn: '',
        prev_hos: 0,
        prev_hos_comment: '',
        prev_hos_comment_bn: '',
        prev_other_hos: 0,
        prev_other_hos_comment: '',
        prev_other_hos_comment_bn: '',
        reg_dss: 0,
        reg_dss_comment: '',
        reg_dss_comment_bn: '',
        pat_eligibility: 0,
        pat_eligibility_comment: '',
        pat_eligibility_comment_bn: ''
      },
      med_assistance: {
        case_history_main_id: 0,
        assistance_type_id: 0,
        rehab_description: '',
        rehab_description_bn: '',
        receiver_name: '',
        receiver_name_bn: '',
        designation: '',
        designation_bn: '',
        officer_name: '',
        officer_name_bn: '',
        comments: '',
        comments_bn: ''
      },
      info_id: ''
    }
  },
  methods: {
    currentDate () {
      const current = new Date()
      const date = `${current.getFullYear()}/${current.getMonth() + 1}/${current.getDate()}`
      return date
    },
    onComplete: function () {
      // const item = { id: this.info_id }
      // toggleStatus(hospitalServiceBaseUrl, MappingFormStatus, item, '', '')
      // this.$router.push({ path: 'hospital-disability-service/social-service/case-history-add' })
    },
    async tabSubmitPersonal () {
        // return true
      let result = null
      const patientType = this.patient_form.patient_type_id
      result = await this.$refs.personal.personal_submit()
      if (result.success) {
        this.patient_form = result.patient_info
        this.patient_form.patient_type_id = patientType
        this.patient_form.case_history_main_id = result.case_id
        this.address_family_info.case_history_main_id = result.case_id
        if (result.family_info !== null) {
          this.address_family_info = result.case_info
          this.address_family_info.family_info = result.family_info
        }
        this.address_family_info.case_history_main_id = result.case_id
        this.info_id = result.case_id
        return true
      }
    },
    async tabSubmitAddress () {
      // return true
      let result = null
      const patientType = this.patient_form.patient_type_id
      result = await this.$refs.address.family_submit()
      if (result.success) {
        this.patient_form = result.patient_info
        this.patient_form.patient_type_id = patientType
        this.address_family_info = result.case_info
        this.admisson_other_info.case_history_main_id = result.case_info.id
        if (result.family_info !== null) {
          this.address_family_info.family_info = result.family_info
          this.admisson_other_info.case_history_main_id = result.case_info.id
        }
        if (result.other_info !== null) {
          this.admisson_other_info = result.other_info
          this.admisson_other_info.related_documents = result.documents_info
        }
        this.admisson_other_info.case_history_main_id = result.case_info.id
        this.patient_form.case_history_main_id = result.case_info.id
        this.info_id = result.case_info.id
        return true
      }
    },
    async tabSubmitAdmission () {
      let result = null
      const patientType = this.patient_form.patient_type_id
      result = await this.$refs.admission.admission_submit()
      if (result.success) {
        this.patient_form = result.patient_info
        this.patient_form.patient_type_id = patientType
        this.admisson_other_info = result.other_info
        this.admisson_other_info.related_documents = result.documents_info
        if (result.med_assistance !== null) {
          this.med_assistance = result.med_assistance
        }
        this.med_assistance.case_history_main_id = result.case_info.id
        if (result.socio !== null) {
          this.socio_ecio = result.socio
        }
        this.socio_ecio.case_history_main_id = result.case_info.id
        this.info_id = result.case_info.id
        return true
      }
    },
    async finalSubmit () {
      // let result = null
      // const patientType = this.patient_form.patient_type_id
      // result = await this.$refs.info.submit()
      // if (result.success) {
      //   this.patient_form = result.patient_info
      //   this.patient_form.patient_type_id = patientType
      //   this.admisson_other_info = result.other_info
      //   this.admisson_other_info.related_documents = result.documents_info
      //   this.info_id = result.case_info.id
      //   return true
      // }
      return true
    },
    async addForm () {
      let result = null
      // const patientType = this.patient_form.patient_type_id
      result = await this.$refs.info.submit()
      if (result.success) {
        this.$router.push({ path: '/hospital-disability-service/social-service/case-history' })
      }
    },
    setLang () {
     this.lang = this.$i18n.locale
    }
  }
}
</script>

<style scoped>
  .vue-form-wizard .navbar .navbar-nav>li>a.wizard-btn, .vue-form-wizard .wizard-btn-custom {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-width: 2px;
    background-color: transparent;
    font-size: 14px;
    font-weight: 600;
    padding: 6px 12px;
    min-width: 140px;
    display: inline-block;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    font-size: 14px;
}
</style>
